// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // appUrl: 'https://diwandevapi.expertapps.com.sa.com.sa', // DEV
  // apiUrl: 'https://diwandevapi.expertapps.com.sa/api', // DEV
  // signalR: 'https://diwandevslr.expertapps.com.sa/hubs', // DEV

  appUrl: 'https://diwantest.expertapps.com.sa', // TEST
  apiUrl: 'https://diwantestapi.expertapps.com.sa/api', // TEST API front
  signalR: 'https://diwantestslr.expertapps.com.sa/hubs', // TEST SignalR

  // appUrl: 'https://diwanstage.expertapps.com.sa', // STAGE
  // apiUrl: 'https://diwanapistage.expertapps.com.sa/api', // STAGE API front
  // signalR: 'https://diwandevslr.expertapps.com.sa/hubs', // STAGE SignalR

  // appUrl: 'https://diwantakeawayadmin.expertapps.com.sa', // STAGE
  // apiUrl: 'https://diwantakeawayapi.expertapps.com.sa/api', // STAGE API front
  // signalR: 'https://diwantakeawayslr.expertapps.com.sa/hubs', // STAGE SignalR

  googleSiteKey: '6Lfm3xohAAAAALgLSfUIY8YHdzC16AjLY6wl7U9a',
  googleApiKey: '6Lfm3xohAAAAADEauzDDPzU0YVrIxWTBbi1k3AkE',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
